import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  MenuItem,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Divider,

} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import TiSLogo from "../assets/TiS_Logo.jpg";


const menuData = {
  Services: ["Explore Our Services", "Big Data Analytics", "IT Staffing", "Websites & Web Apps", "Operational Analytics"],
  Industries:["Explore All Industries", "Automobile", "Healthcare","Banking & Finance", "Education", "Retail", "Manufacturing"],
};

const Navbar = () => {
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [menuOpenedByClick, setMenuOpenedByClick] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});
  let submenuTimeout = null;

  // Navigation function
  const handleNavigation = (path) => {
    navigate(path);
    setSelectedMenu(null);
    setIsDrawerOpen(false);
  };

  const handleHomeNavigation = () => {
    navigate("/");
    window.scrollTo(0, 0); 
  };

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const handleMenuOpen = (menu) => {
    clearTimeout(submenuTimeout);
    setSelectedMenu(menu);
  };

  const handleMenuClose = () => {
    submenuTimeout = setTimeout(() => {
      setSelectedMenu(null);
    }, 200);
  };

  const handleMenuClick = (menu) => {
    if (selectedMenu === menu && menuOpenedByClick) {
      setSelectedMenu(null);
      setMenuOpenedByClick(false);
    } else {
      handleMenuOpen(menu);
      setMenuOpenedByClick(true);
    }
  };

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: "white", color: "black", padding: "10px 0", boxShadow: "none", zIndex: 1100 }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          
          {/* Logo + Title (Navigates to Home) */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              cursor: "pointer",
              ml: { xs: 0, md: -3 }, 
            }}
            onClick={handleHomeNavigation}
          >
            <Box component="img" src={TiSLogo} alt="Logo" sx={{ height: { xs: 50, md: 60 }, marginLeft: 0 }} />
            <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: { xs: "14px", md: "18px" }, ml: { xs: 1, md: 1 } }}>
              TECH INFORMATIC SOLUTIONS
            </Typography>
          </Box>



           {/* Desktop Navigation */}
          

          {/* Desktop Navigation */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, justifyContent: "center", gap: 3 }}>
            {Object.keys(menuData).map((menu) => (
              <Box key={menu} sx={{ position: "relative", textAlign: "center" }} onMouseEnter={() => handleMenuOpen(menu)} onMouseLeave={handleMenuClose}>
                <Button onClick={() => handleMenuClick(menu)} sx={{ fontWeight: "bold", textTransform: "none", fontSize: "16px" }}>
                  {menu}
                  {menuData[menu] && <ExpandMoreIcon sx={{ fontSize: "18px", marginLeft: "4px" }} />}
                </Button>

                {/* Submenu */}
                {selectedMenu === menu && menuData[menu] && (
                  <Box
                    onMouseEnter={() => handleMenuOpen(menu)}
                    onMouseLeave={handleMenuClose}
                    sx={{
                      position: "absolute",
                      top: "58px",
                      left: "0",
                      width: "180px",
                      backgroundColor: "white",
                      boxShadow: 3,
                      display: "flex",
                      flexDirection: "column",
                      padding: "10px 0",
                      zIndex: 1000,
                      borderRadius: "4px",
                      borderTop: "6px solid #6A7FB5",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        top: "-22px",
                        left: "10px",
                        width: "0",
                        height: "0",
                        borderLeft: "18px solid transparent",
                        borderRight: "18px solid transparent",
                        borderBottom: "18px solid #6A7FB5",
                      },
                    }}
                    >
                    {menuData[menu].map((item, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => {
                          if (item === "Explore Our Services") {
                            handleNavigation("/servicehome"); // ✅ Navigates to ServiceHome.js
                          } else if (item === "Big Data Analytics") {
                            handleNavigation("/bigdata"); // ✅ Navigates to Bigdata.js
                          }else if (item === "IT Staffing") {
                            handleNavigation("/itstaffing"); // ✅ Navigates to Bigdata.js
                          }else if (item === "Websites & Web Apps") {
                            handleNavigation("/websites"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Operational Analytics") {
                            handleNavigation("/opeana"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Explore All Industries") {
                            handleNavigation("/industrieshome"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Healthcare") {
                            handleNavigation("/health"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Automobile") {
                            handleNavigation("/automobile"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Banking & Finance") {
                            handleNavigation("/banking"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Education") {
                            handleNavigation("/education"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Retail") {
                            handleNavigation("/retail"); // ✅ Navigates to Bigdata.js
                          }
                          else if (item === "Manufacturing") {
                            handleNavigation("/manufacturing"); // ✅ Navigates to Bigdata.js
                          }
                        
                          else {
                            setSelectedMenu(null);
                          }
                        }}
                        sx={{
                          padding: "8px 16px",
                          fontSize: "14px",
                          "&:hover": { backgroundColor: "#f4f4f4", borderLeft: "3px solid #6A7FB5", color: "#1976D2", fontWeight: "bold" },
                        }}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Box>
                )}
              </Box>
            ))}


             {/* Careers - Navigates Directly */}
  <Button
              onClick={() => handleNavigation("/careers")}
              sx={{
                fontWeight: "bold",
                textTransform: "none",
                fontSize: "16px",
              }}
            >
             Careers
            </Button>

         

  {/* About Us - Navigates Directly */}
  <Button
              onClick={() => handleNavigation("/about")}
              sx={{
                fontWeight: "bold",
                textTransform: "none",
                fontSize: "16px",
              }}
            >
              About Us
            </Button>

          </Box>

         
          
          
         




           {/* Right: Contact Button */}
           <Button
            variant="outlined"
            sx={{
              display: { xs: "none", md: "block" },
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "16px",
              color: "white",
              padding: "5px 15px",
              backgroundColor: "grey",
              borderRadius: "30px",
              "&:hover": { backgroundColor: "black", color: "white", border: "1px solid black" },
            }}
            onClick={() => navigate("/contact")}
          >
            Contact
          </Button>




          {/* Mobile Menu Button */}
          <IconButton edge="end" onClick={toggleDrawer(true)} sx={{ display: { xs: "block", md: "none" }, mr: 2 }}>
            <MenuIcon sx={{ fontSize: "32px" }} />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer Menu */}
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
      <Box sx={{ width: 250, textAlign: "center", padding: 2 }}>
          
          {/* Logo + Title in Drawer (Click to Navigate & Close Drawer) */}
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => {
              handleHomeNavigation();
              setIsDrawerOpen(false);
            }} 
          >
            <Box component="img" src={TiSLogo} alt="Logo" sx={{ height: 50, marginBottom: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>TECH INFORMATIC SOLUTIONS</Typography>
          </Box>
          <Divider sx={{ margin: "10px 0" }} />
        </Box>


        <List>
          {Object.keys(menuData).map((menu) => (
            <React.Fragment key={menu}>
              <ListItem button onClick={() => setExpandedMenus((prev) => ({ ...prev, [menu]: !prev[menu] }))}>
                <ListItemText primary={menu} />
                {menuData[menu] ? (expandedMenus[menu] ? <ExpandLessIcon /> : <ExpandMoreIcon />) : null}
              </ListItem>
              <Collapse in={expandedMenus[menu]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {menuData[menu]?.map((subItem, index) => (
                    <ListItem key={index} sx={{ pl: 4 }} button onClick={() => {
                      if (subItem === "Explore Our Services") {
                        handleNavigation("/servicehome"); // ✅ Navigates to ServiceHome.js
                      }else if (subItem  === "Big Data Analytics") {
                        handleNavigation("/bigdata"); // ✅ Navigates to Bigdata.js
                      }else if (subItem  === "IT Staffing") {
                        handleNavigation("/itstaffing"); // ✅ Navigates to Bigdata.js
                      }else if (subItem  === "Websites & Web Apps") {
                        handleNavigation("/websites"); // ✅ Navigates to Bigdata.js
                      }else if (subItem  === "Operational Analytics") {
                        handleNavigation("/opeana"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Explore All Industries") {
                        handleNavigation("/industrieshome"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Healthcare") {
                        handleNavigation("/health"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Automobile") {
                        handleNavigation("/automobile"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Banking & Finance") {
                        handleNavigation("/banking"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Education") {
                        handleNavigation("/education"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Retail") {
                        handleNavigation("/retail"); // ✅ Navigates to Bigdata.js
                      }
                      else if (subItem === "Manufacturing") {
                        handleNavigation("/manufacturing"); // ✅ Navigates to Bigdata.js
                      }
                      
                    }}>
                      <ListItemText primary={subItem} />
                    </ListItem>




                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ))}
         


         <ListItem sx={{ pl: 1}}>
    <Button
      onClick={() => handleNavigation("/careers")}
      sx={{
        color: "black",
        textTransform: "none",
        fontSize: "16px",
        width: "100%", // Ensures it takes full width
        justifyContent: "flex-start",
      }}
    >
      Careers
    </Button>
  </ListItem>

        

    <ListItem sx={{ pl: 1}}>
    <Button
      onClick={() => handleNavigation("/about")}
      sx={{
        color: "black",
        textTransform: "none",
        fontSize: "16px",
        width: "100%", // Ensures it takes full width
        justifyContent: "flex-start",
      }}
    >
      About Us
    </Button>
  </ListItem>

  {/* Contact Button - Now Below "About Us" */}
  <ListItem sx={{ pl: 1}}>
    <Button
      onClick={() => navigate("/contact")}
      sx={{
        color: "black",
        textTransform: "none",
        fontSize: "16px",
        width: "100%", // Ensures it takes full width
        justifyContent: "flex-start",
      }}
    >
      Contact
    </Button>
  </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
